import classes from './YooKassa.module.sass'
import { useYooKassa } from './hooks/useYooKassa'
import { YooKassaStage } from '../../../../../common/types/enums'

import { Result } from '../../../../../common/components/result/Result'

type Props = {
  yoomoneyToken: string
  paymentId: string
   onSuccess?: () => void 
}

export const YooKassa = ({ yoomoneyToken, paymentId }: Props) => {
  const { stage } = useYooKassa(yoomoneyToken, paymentId)

  if (stage === YooKassaStage.WIDGET)
    return (
      <div className={classes.Container}>
        <div id="payment_form" />
      </div>
    )
  if (stage === YooKassaStage.SUCCESS)
    return (
      <div className={classes.Container}>
        <Result />
        <div className={classes.Message}>Оплата прошла успешно</div>
      </div>
    )
  if (stage === YooKassaStage.ERROR)
    return (
      <div className={classes.Container}>
        <Result negative />
        <div className={classes.Message}>Оплата не прошла</div>
      </div>
    )
}
